import { Column} from 'react-table'
import { DLMSiteApplicationsActionsCell } from './DLMSiteApplicationsActionsCell'
import { ShowDateCell, ApplicationStateCell, MarkerBadge } from '../../../../../../../components/widgets'
import { DLMSiteApplication } from '../../../../_models'
import { DLMApplicationTerminationStates } from '../../../../_constants'
import { DLMSiteApplicationsROICell } from './DLMSiteApplicationsROICell'
import { DLMSiteApplicationsNotesCell } from './DLMSiteApplicationsNotesCell'

const DLMSiteApplicationsColumns: ReadonlyArray<Column<DLMSiteApplication>> = [
  {
    Header: 'Actions',
    minWidth: 125,    
    id: 'actions',
    Cell: ({...props}) => <DLMSiteApplicationsActionsCell
      site={props.data[props.row.index]}
    />,
  },
  {
    Header: 'State',
    minWidth: 80,
    id: 'state',
    Cell: ({...props}) => 
    <div className="d-flex flex-row align-items-center gap-1">            
      <ApplicationStateCell state_val={props.data[props.row.index].state} className='min-w-225px' />
      <MarkerBadge state={props.data[props.row.index].requestTerminateState} states={DLMApplicationTerminationStates} />            
    </div>
  },
  {
    Header: '',
    minWidth: 20,    
    id: 'notes',
    Cell: ({...props}) => <DLMSiteApplicationsNotesCell notes={props.data[props.row.index].notes} terminationNotes={props.data[props.row.index].requestTerminateNotes} />,
  },    
  {
    Header: 'Project Name',
    minWidth: 125,    
    accessor: 'projectName',
  },    
  {
    Header: 'Client Ref No',
    minWidth: 80,    
    accessor: 'clientRefNo',
  },
  {
    Header: 'ROI',
    minWidth: 125,    
    id: 'roiFiles',
    Cell: ({...props}) => <DLMSiteApplicationsROICell site={props.data[props.row.index]} />,
  },
  {
    Header: 'Last Update',
    minWidth: 125,    
    id: 'dteUpd',
    Cell: ({...props}) => <ShowDateCell date_val={props.data[props.row.index].dteUpd} />,
  },
]

export {DLMSiteApplicationsColumns}
